import { LayoutRoute, Route } from "@soft-db/typed-router";

const profileRoutes = new LayoutRoute({
	name: "user_profile",
	path: "profile",
	component: () => import("@/pages/profile.vue"),
	meta: {
		feature: "userSettings",
	},
	children: [
		new Route({
			path: "",
			component: () => import("@/pages/profile/index.vue"),
		}),
	],
});

export default profileRoutes;
